import { render, staticRenderFns } from "./ConfigTags.vue?vue&type=template&id=4dc742a9&scoped=true"
import script from "./ConfigTags.vue?vue&type=script&lang=js"
export * from "./ConfigTags.vue?vue&type=script&lang=js"
import style0 from "./ConfigTags.vue?vue&type=style&index=0&id=4dc742a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc742a9",
  null
  
)

export default component.exports